import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ButtonBase, Stack, } from "@mui/material";
import { CollapseIcon } from "./CollapseIcon.js";
export const CollapseButton = ({ isExpanded, setIsExpanded, title, color, ...props }) => {
    return (_jsx(CollapseButtonBase, { title: title, onClick: (e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsExpanded?.(!isExpanded);
        }, startIcon: _jsx(CollapseIcon, { isCollapsed: !isExpanded, color: color }), ...props }));
};
export const CollapseButtonBase = ({ title, fullWidth, startIcon, endIcon, ...props }) => {
    return (
    // @ts-ignore
    _jsxs(StackAsButton, { direction: "row", alignItems: "center", spacing: 0.5, p: 0.5, pr: !title || endIcon ? 0.5 : 1.5, minHeight: "30px", width: fullWidth ? "100%" : undefined, minWidth: 0, ...props, children: [startIcon && (_jsx(Box, { height: "20px", display: "flex", alignItems: "center", flexShrink: 0, flexGrow: 0, children: startIcon })), title && (_jsx(Box, { display: "flex", flex: 1, minWidth: 0, children: title })), endIcon && (_jsx(Box, { height: "20px", display: "flex", alignItems: "center", flexShrink: 0, flexGrow: 0, children: endIcon }))] }));
};
const StackAsButton = ({ ...props }) => {
    return (
    // @ts-ignore
    _jsx(Stack, { component: ButtonBase, focusRipple: true, sx: theme => ({
            borderRadius: "4px",
            transition: "background-color 0.1s ease-out",
            ["&:hover"]: {
                backgroundColor: theme.palette.action.hover,
            },
            ["&:active"]: {
                backgroundColor: theme.palette.action.selected,
            },
            [".MuiTouchRipple-root"]: { margin: 0 },
        }), ...props }));
};
//# sourceMappingURL=CollapseButton.js.map